import { jsx as _jsx } from "react/jsx-runtime";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext } from "react";
import { SearchInput } from "../SearchAutocompleteInput";
import { SearchFormContext } from "../SearchFormContext";
export function QueryAutocompleteInput() {
    var _a = useContext(SearchFormContext), queryParamKey = _a.queryParamKey, queryValue = _a.queryValue, setQueryValue = _a.setQueryValue;
    return (_jsx(SearchInput, { placeholder: "Job title, keywords or company", paramKey: queryParamKey, value: queryValue, setValue: setQueryValue, icon: _jsx(FontAwesomeIcon, { icon: faMagnifyingGlass }) }));
}
